<template>
  <section id="userDetail" class="pt-2">
    <v-snackbar
      :timeout="5000"
      :value="message.show"
      absolute
      top
      :color="message.type"
    >
      <v-alert :type="message.type" class="mb-0"> {{ message.text }} </v-alert>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="message.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-row class="ma-0 px-2">
      <v-spacer></v-spacer>
      <v-btn tile outlined class="error white--text" @click="dialog = true"
        >删除</v-btn
      >
      <v-btn
        tile
        outlined
        class="success white--text ml-2"
        @click="onSave"
        v-if="!userId"
        >保存</v-btn
      >
      <v-btn
        tile
        outlined
        class="success white--text ml-2"
        @click="onEdit"
        v-else
        >保存</v-btn
      >
    </v-row>
    <div id="detailForm">
      <v-form class="px-4" ref="form" v-model="valid" lazy-validation>
        <p class="subtitle-1 font-weight-bold">用户基础信息</p>
        <v-text-field
          outlined
          dense
          label="用户名"
          :rules="[(v) => !!v || '这是必填项']"
          v-model="user.username"
          clearable
        ></v-text-field>
        <v-text-field
          outlined
          dense
          label="昵称"
          :rules="[(v) => !!v || '这是必填项']"
          v-model="user.displayName"
          clearable
        ></v-text-field>
        <!-- <v-text-field outlined dense label="联系方式"></v-text-field> -->
        <v-autocomplete
          outlined
          dense
          label="角色"
          :rules="[(v) => !!v || '这是必填项']"
          v-model="user.role"
          item-text="name"
          return-object
          :items="roleList"
          @change="setRole($event)"
        ></v-autocomplete>
        <v-autocomplete
          outlined
          dense
          label="所属区域"
          :rules="[(v) => !!v || '这是必填项']"
          v-model="user.regionCode"
          item-text="regionName"
          item-value="regionCode"
          :items="regionList"
          @change="setRegion($event)"
          v-if="user?.role?.code != 'HOD' && user?.role?.code != 'RRS' && user?.role?.code != 'SCN'"
        ></v-autocomplete>
        <v-autocomplete
          outlined
          clearable
          dense
          label="省/直辖市 "
          :items="provinceList"
          item-value="code"
          :rules="[(v) => !!v || '这是必填项']"
          item-text="name"
          v-model="user.provinceCode"
          @change="setProvince($event)"
          v-if="user?.role?.code === 'Sell-in Sales'"
        ></v-autocomplete>
        <v-autocomplete
          outlined
          clearable
          dense
          label="市"
          :items="cityList"
          item-value="code"
          item-text="name"
          v-model="user.cityCode"
          @change="setCity($event)"
          v-if="user?.role?.code === 'Sell-in Sales'"
        ></v-autocomplete>
      </v-form>
    </div>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">提示</span>
        </v-card-title>
        <v-card-text>
          <span>确认删除吗？</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">
            关闭
          </v-btn>
          <v-btn color="blue darken-1" text @click="onDelete"> 确认 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </section>
</template>

<script>
import api from "../../api/api";
export default {
  name: "UserDetail",
  data: () => ({
    loading: false,
    dialog: false,
    valid: false,
    pickDate: false,
    message: {
      show: false,
      type: "success",
      text: "",
    },
    userId: null,
    user: {
      username: null,
      displayName: null,
      regionCode: null,
      regionName: null,
      provinceCode: null,
      provinceName: null,
      cityCode: null,
      cityName: null,
      role: null,
      userRoles: null,
    },
    provinceList: [],
    cityList: [],
    districtList: [],
    roleList: [],
    regionList: [],
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.params.id != 0) {
        vm.getUserInfo(Number(to.params.id));
      }
      vm.getRegion();
      vm.getRoles();
    });
  },
  mounted(){
    this.getRegion()
  },
  methods: {
    getRegion() {
      api.pca.getRegion().then((res) => {
        const { data, status } = res.data;
        if (status == 200 && data) {
          this.regionList = data;
        }
      });
    },
    getProvince(byRegion) {
      if (byRegion) {
        this.provinceList = api.pca.getProvince().filter((i) => {
          return (
              byRegion.filter((pro) => pro.provinceCode === i.code).length > 0
          );
        });
      } else {
        this.provinceList = api.pca.getProvince();
      }
    },
    setProvince($event) {
      const selectedProvince = this.provinceList.filter(
        (i) => i.code == $event
      )[0];
      this.cityList = api.pca.getCityByProvince($event);
      this.user.cityCode = null;
      this.user.cityName = null;
      this.user.provinceName = selectedProvince.name;
    },
    setCity($event) {
      const selectedCity = this.cityList.filter((i) => i.code == $event)[0];
      this.user.cityName = selectedCity.name;
    },
    setRegion($event) {
      const selectedRegion = this.regionList.filter(
        (i) => i.regionCode == $event
      )[0];
      this.getProvince(selectedRegion?.provinces);
      this.user.regionName = selectedRegion.regionName;
      this.user.provinceCode = null;
      this.user.provinceName = null;
      this.user.cityCode = null;
      this.user.cityName = null;
    },
    setRole($event) {
      this.user.userRoles = [$event];
    },
    getRoles() {
      api.user.getRoleList().then((res) => {
        const { data, status } = res.data;
        if (data && status == 200) {
          this.roleList = data.list;
        }
      });
    },
    getUserInfo(id) {
      this.userId = id;
      this.loading = true;
      api.user
        .getUserById({ id })
        .then((res) => {
          if (res.data.data) {
            this.user = {
              ...res.data.data,
              role: res.data.data.userRoles[0],
            };
            const selectedRegion = this.regionList.filter(
                (i) => i.regionCode === res.data.data.regionCode
            )[0];
            //debugger首先获取region再获取省份
            this.getProvince(selectedRegion?.provinces);
            this.cityList = api.pca.getCityByProvince(this.user.provinceCode);
          }
        })
        .catch((err) => {
          console.log(err);
          this.message = {
            show: true,
            type: "error",
            text: "数据加载失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    onDelete() {
      this.loading = true;
      api.user
        .deleteUser({
          id: this.userId,
        })
        .then((res) => {
          if (res.data.status == 200) {
            this.message = {
              show: true,
              type: "success",
              text: "删除成功！",
            };
            this.$router.push({
              path: "/distributor",
            });
          } else {
            this.message = {
              show: true,
              type: "error",
              text: "删除失败，请重试！",
            };
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "保存失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          this.dialog = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    onSave() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      const data = {
        ...this.user,
      };
      api.user
        .addUser(data)
        .then((res) => {
          if (res.data.status == 200) {
            this.message = {
              show: true,
              type: "success",
              text: "保存成功！",
            };
            setTimeout(() => {
              this.$router.push({
                path: "/user",
              });
            }, 1000);
          } else {
            this.message = {
              show: true,
              type: "error",
              text: "保存失败，请重试！",
            };
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "保存失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    onEdit() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      const data = {
        ...this.user,
      };
      api.user
        .editUser(data)
        .then((res) => {
          if (res.data.status == 200) {
            this.message = {
              show: true,
              type: "success",
              text: "保存成功！",
            };
            setTimeout(() => {
              this.$router.push({
                path: "/user",
              });
            }, 1000);
          } else {
            this.message = {
              show: true,
              type: "error",
              text: "保存失败，请重试！",
            };
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "保存失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
  },
};
</script>

<style lang="sass">
#userDetail
  height: calc(100% - 48px)
  width: 100%
  #detailForm
    width: 100%
    height: calc(100% - 40px)
    overflow: auto
</style>
